function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.4367 17.9866H15.4112H7.85333L3 52.0755H51.5333L46.68 17.9866H39.0967V25.2666H34.85V17.9866H20.8842H19.6833V25.2666H15.4367V17.9866Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.2668 1.30322C33.6678 1.30322 38.9161 6.44311 39.0922 12.8032L39.0968 13.1332V17.9866H34.8501V13.1332C34.8501 8.96724 31.4327 5.54989 27.2668 5.54989C23.1934 5.54989 19.8357 8.81705 19.6885 12.8566L19.6834 13.1332V17.9866H15.4368V13.1332C15.4368 6.62187 20.7554 1.30322 27.2668 1.30322Z",
  opacity: 0.6
});

function SvgShopper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopper);
export default __webpack_public_path__ + "static/media/shopper.2804f26c.svg";
export { ForwardRef as ReactComponent };